import { GrossMarginRequestDetail } from "@/services/gross-margin-requests.service"
import { AppColors } from "@/styles/colors"
import { Box, Flex, Text } from "@chakra-ui/react"

interface Props {
    detail: GrossMarginRequestDetail
}

export const RequestedHarvestList = ({ detail }: Props) => {

    return (
        <Box>
            <Text fontWeight={700} fontSize="16px" marginBottom="12px">
                Cultivos Solicitados
            </Text>
            <Flex flexDir="column" gap="8px">
                {detail.cultivos.map((c, i) => (
                    <Flex
                        key={i}
                        border="1px solid"
                        borderColor="gray.200"
                        borderRadius="6px"
                        paddingX="16px"
                        paddingY="12px"
                        alignItems="center"
                        gap="24px"
                    >
                        <Text fontWeight={600} fontSize="14px" minW="100px">
                            {c.granoProductivo.nombre}
                        </Text>
                        <Text fontSize="14px" color={AppColors.GRAY_TEXT}>
                            Rinde indicado: {c.rindeIndicado} qq
                        </Text>
                    </Flex>
                ))}
            </Flex>
        </Box>
    )
}